import { Grid, TableCell, TableRow, Typography } from '@mui/material';
import React from 'react';

const ExpandedRecibosComponent = ({ data, rowData }) => {
  return (
    <TableRow>
      <TableCell colSpan={rowData.length} sx={{ p: 2 }}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Typography variant="body1" color="initial">
              <strong>Descripción: </strong>
              {data.desc || '--'}
            </Typography>
            <Typography variant="body1" color="initial">
              <strong>Descripción del pago: </strong>
              {data.descPago || '--'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={3} align="center">
            <strong>Fecha de creación</strong>
            <br />
            {data.createdAt}
          </Grid>
          <Grid item xs={12} md={3} align="center">
            <strong>Fecha de edición</strong>
            <br />
            {data.updatedAt}
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default ExpandedRecibosComponent;
